import { registerQuery } from '@adornis/baseql/metadata/register.js';
import { getRawCollection } from '@adornis/baseql/server/collections.js';
import type { BaseQLSelectionSet } from '@adornis/baseql/utils/queryGeneration.js';
import { MailProcessing } from '../db/MailExtractionResult.js';
import { MonthOfYear } from '../db/MailProcessingFilter.js';

export const getMailProcessingFilterMonths = registerQuery({
  type: () => [MonthOfYear],
  operationName: 'getMailProcessingFilterMonths',
  resolve: () => {
    return async (gqlFields: BaseQLSelectionSet<MonthOfYear>) => {
      const mailProcessingCollection = await getRawCollection<MailProcessing>(MailProcessing._collectionName);
      const monthResults = await mailProcessingCollection
        .aggregate<{ _id: { year: number; month: number } }>([
          {
            $group: {
              _id: {
                year: { $year: '$createdAt' },
                month: { $month: '$createdAt' },
              },
            },
          },
          { $sort: { '_id.year': -1, '_id.month': -1 } },
        ])
        .toArray();

      return monthResults.map(res => {
        return MonthOfYear.create({ year: res._id.year, month: res._id.month });
      });
    };
  },
});
